import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography
} from '@mui/material';

import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

export const InsuranceCard = ({
  orderData
}) => {
  const handleDownloadPolicy = () => {
    console.log('download policy');
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2],
        height: '100%'
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <HealthAndSafetyOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Ubezpieczenie NNW
          </Typography>
        </Stack>

        <Stack spacing={3}>
          <Box>
            <Typography
              color="text.secondary"
            >
              Numer polisy
            </Typography>

            <Typography
              variant="h6"
              fontWeight={700}
              color="red"
            >
              {orderData.insurance_policy_number ||
                'Polisa NNW będzie dostępna w marcu.'}
            </Typography>
          </Box>

          <Box>
            <Typography
              color="text.secondary"
            >
              Suma ubezpieczenia
            </Typography>

            <Typography
              variant="h6"
              fontWeight={700}
              color="red"
            >
              {orderData.insurance_amount
                ? `${orderData.insurance_amount} zł`
                : 'Polisa NNW będzie dostępna w marcu.'}
            </Typography>
          </Box>

          <Box>
            <Typography
              color="text.secondary"
            >
              Zakres
            </Typography>

            <Typography>
              Ubezpieczenie następstw
              nieszczęśliwych wypadków
              (NNW) uczestników
              wyjazdu.
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={
              <DownloadOutlinedIcon />
            }
            onClick={
              handleDownloadPolicy
            }
            disabled
          >
            Pobierz polisę
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
